import { render, staticRenderFns } from "./SurgicalCaseRelatedList.vue?vue&type=template&id=6967130b&scoped=true&"
import script from "./SurgicalCaseRelatedList.vue?vue&type=script&lang=js&"
export * from "./SurgicalCaseRelatedList.vue?vue&type=script&lang=js&"
import style0 from "./SurgicalCaseRelatedList.vue?vue&type=style&index=0&id=6967130b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967130b",
  null
  
)

export default component.exports